import type { Maybe } from '@adornis/base/utilTypes.js';
import { Field } from '@adornis/baseql/decorators.js';
import { Entity } from '@adornis/baseql/decorators/entity.js';
import { MicrosoftData } from './MicrosoftData.js';

@Entity()
export class MicrosoftGroupData extends MicrosoftData {
  static override _class = 'MicrosoftGroupData';

  @Field(type => String)
  public mailNickname: Maybe<string>;

  @Field(type => String)
  public description: Maybe<string>;

  @Field(type => Boolean, { default: v => v ?? false })
  public secureGroup: Maybe<boolean>;

  @Field(type => String, { default: v => v ?? 'Public' })
  public visibility: Maybe<'Private' | 'Public'>;
}
